import React from 'react';
import PropTypes from 'prop-types';
import { hexToRgbColor } from '../../../../helpers/genericFormator';

export default function StatusFormatter(props) {
  const { data = {} , isBlocked = false} = props;

  let color = data.color_code ? data.color_code : '#788195';
  let border = '1px solid' + `${data?.color_code || '#788195'}`;
  let styleObject = {
    color: color,
    border: border,
    padding: '4px 14px',
    borderRadius: '16.5px',
    backgroundColor: `rgb(${hexToRgbColor(color)}, 0.1)`,
    width: 'fit-content',
    display: 'flex',
  };

  return (
    <div>
      <div style={styleObject}>
        <span
          className="font-14 fw-500"
          style={{ color: data.color_code, letterSpacing: '0.1px' }}
        >
          {isBlocked ? 'Request in process' : data?.name}
        </span>
      </div>
    </div>
  );
}

StatusFormatter.propTypes = {
  data: PropTypes.string,
};
